<div class="ipm-billing-section">
    <div class="ipm-billing-address-heading">
        <h1>Select Billing Address</h1>
        <div class="ipm-close-icon" (click)="closeDialog()">
            <i class="pi pi-times"></i>
        </div>
    </div>
    <ipm-billing-addresses (onSelectedData)="onSelectedAddress($event)" [isDefaultSelected]="true" [isShowScrollbar]="true"  [isShowAll]="true" [disableAutoPopup]="true" (checkBillingList)="checkBillingList($event)" [defaultDialogType]="'billingType'" [isInsidePopup]="true" (addNewClicked)="onAddNewClicked()" #billingAddress></ipm-billing-addresses>
    <div class="ipm-billing-address-action">
        <!-- <div class="checkout-flow" *ngIf="isShowTermConditions">
            <mat-checkbox 
                [(ngModel)]="isAcceptTermCondition"
                required>
                Agree on terms and conditions 
            </mat-checkbox>
        </div> -->
        <button class="btn ipm-checkout-btn"
        [disabled]="!currentAddressSelected"
        (click)="paymentMethod()">
            Continue to payment
        </button>
    </div>
</div>